import {
  CustomerComments,
  CustomerContacts,
  CustomerOrders,
  CustomerParts,
  CustomerQuotes,
} from "../../containers";

export const tabs = [
  {
    id: "orders",
    label: "Orders",
    view: <CustomerOrders hideBar />,
  },
  {
    id: "contacts",
    label: "Contacts",
    view: <CustomerContacts hideBar />,
  },
  {
    id: "parts",
    label: "Parts",
    view: <CustomerParts hideBar />,
  },
  {
    id: "quotes",
    label: "Quotes",
    view: <CustomerQuotes />,
  },
  {
    id: "comments",
    label: "Comments",
    view: <CustomerComments />,
  },
];

export const getAction = (tabId, { hasParts, isVendor }) => {
  switch (tabId) {
    case "orders": {
      const disabled = !hasParts && !isVendor;
      return {
        name: "purchase-order-create",
        label: "Create Order",
        ...(disabled
          ? {
              disabled: true,
              hoverTitle: "Customer Has No Parts",
              hoverSubtitle: "Cannot create order for customer without parts",
            }
          : {}),
      };
    }
    case "contacts":
      return {
        name: "edit-contact",
        label: "Create Contact",
      };
    case "parts":
      return {
        name: "create-customer-part",
        label: "Create Part",
      };
    default:
      return null;
  }
};
